// Symbols with number 2 at the end of their isin are retail
export function isRetail(isin: string): boolean {
  return isin?.slice?.(-1) === '2';
}
